// API Converter utility to convert OpenAPI 2.0 to 3.0
export const convertSwagger2ToOpenAPI3 = (swagger2Spec) => {
  const openAPI3Spec = {
    openapi: "3.0.0",
    info: {
      title: swagger2Spec.info?.title || "API Documentation",
      description: swagger2Spec.info?.description || "",
      version: swagger2Spec.info?.version || "1.0.0",
      contact: swagger2Spec.info?.contact || {},
      license: swagger2Spec.info?.license || {}
    },
    servers: [
      {
        url: swagger2Spec.host ? `https://${swagger2Spec.host}` : "https://api.techgenzi.com",
        description: "server"
      }
    ],
    paths: {},
    components: {
      schemas: {},
      securitySchemes: {}
    }
  };

  // Convert paths
  if (swagger2Spec.paths) {
    Object.keys(swagger2Spec.paths).forEach(path => {
      const pathItem = swagger2Spec.paths[path];
      openAPI3Spec.paths[path] = {};

      Object.keys(pathItem).forEach(method => {
        if (['get', 'post', 'put', 'delete', 'patch', 'head', 'options'].includes(method)) {
          const operation = pathItem[method];
          openAPI3Spec.paths[path][method] = {
            summary: operation.summary || "",
            description: operation.description || "",
            operationId: operation.operationId || "",
            tags: operation.tags || [],
            parameters: convertParameters(operation.parameters || []),
            requestBody: convertRequestBody(operation),
            responses: convertResponses(operation.responses || {}),
            security: operation.security || []
          };
        }
      });
    });
  }

  // Convert definitions to components.schemas
  if (swagger2Spec.definitions) {
    openAPI3Spec.components.schemas = convertDefinitions(swagger2Spec.definitions);
  }

  // Convert security definitions
  if (swagger2Spec.securityDefinitions) {
    openAPI3Spec.components.securitySchemes = convertSecurityDefinitions(swagger2Spec.securityDefinitions);
  }

  return openAPI3Spec;
};

const convertParameters = (parameters) => {
  return parameters.map(param => ({
    name: param.name,
    in: param.in,
    description: param.description || "",
    required: param.required || false,
    schema: param.schema || { type: param.type || "string" },
    example: param.example
  }));
};

const convertRequestBody = (operation) => {
  if (operation.consumes && operation.consumes.length > 0) {
    return {
      content: {
        [operation.consumes[0]]: {
          schema: operation.parameters?.find(p => p.in === 'body')?.schema || {}
        }
      }
    };
  }
  return undefined;
};

const convertResponses = (responses) => {
  const convertedResponses = {};
  Object.keys(responses).forEach(statusCode => {
    const response = responses[statusCode];
    convertedResponses[statusCode] = {
      description: response.description || "",
      content: response.schema ? {
        "application/json": {
          schema: response.schema
        }
      } : undefined
    };
  });
  return convertedResponses;
};

const convertDefinitions = (definitions) => {
  const schemas = {};
  Object.keys(definitions).forEach(key => {
    schemas[key] = definitions[key];
  });
  return schemas;
};

const convertSecurityDefinitions = (securityDefinitions) => {
  const securitySchemes = {};
  Object.keys(securityDefinitions).forEach(key => {
    const scheme = securityDefinitions[key];
    securitySchemes[key] = {
      type: scheme.type,
      description: scheme.description || "",
      name: scheme.name,
      in: scheme.in,
      scheme: scheme.scheme,
      bearerFormat: scheme.bearerFormat
    };
  });
  return securitySchemes;
};

// Fetch and convert external API
export const fetchAndConvertAPI = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch API: ${response.status}`);
    }
    
    const swagger2Spec = await response.json();
    
    // Check if it's already OpenAPI 3.x
    if (swagger2Spec.openapi && swagger2Spec.openapi.startsWith('3.')) {
      return swagger2Spec;
    }
    
    // Convert from Swagger 2.0 to OpenAPI 3.0
    return convertSwagger2ToOpenAPI3(swagger2Spec);
  } catch (error) {
    console.error('Error fetching/converting API:', error);
    throw error;
  }
}; 